<div class="form-builder-row">
  <div class="form-builder-row-fields">
    <div
      class="form-builder-row-fields-wrapper"
      *ngIf="row.get('type') === 'input'"
    >
      <div class="field is-horizontal">
        <div class="field-label is-small">
          <label class="label">
            <span translationEditableDirective="LABEL">{{
              'LABEL' | translate
            }}</span>
          </label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control">
              <input
                class="input is-small"
                (input)="handleFieldChange({ e: $event })"
                name="label"
                [value]="row.get('label')"
                type="text"
              />
            </p>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label is-small">
          <label class="label">
            <span translationEditableDirective="NAME">{{
              'NAME' | translate
            }}</span>
          </label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control">
              <input
                class="input is-small"
                (input)="handleFieldChange({ e: $event })"
                name="name"
                type="text"
                [value]="row.get('name')"
              />
            </p>
          </div>
        </div>
      </div>
    </div>

    <div
      class="form-builder-row-fields-wrapper"
      *ngIf="row.get('type') === 'select'"
    >
      <div class="field is-horizontal">
        <div class="field-label is-small">
          <label class="label" translationEditableDirective="LABEL">
            <span>{{ 'LABEL' | translate }}</span>
          </label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control">
              <input
                class="input is-small"
                (input)="handleFieldChange({ e: $event })"
                name="label"
                type="text"
                [value]="row.get('label')"
              />
            </p>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label is-small">
          <label class="label">
            <span translationEditableDirective="NAME">{{
              'NAME' | translate
            }}</span>
          </label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control">
              <input
                class="input is-small"
                name="name"
                (input)="handleFieldChange({ e: $event })"
                type="text"
                [value]="row.get('name')"
                [disabled]="isPropertyType"
              />
            </p>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label is-small">
          <label class="label" translationEditableDirective="MULTIPLE">{{
            'MULTIPLE' | translate
          }}</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control" style="padding-top: 5px">
              <input
                type="checkbox"
                (change)="handleFieldChange({ e: $event })"
                name="isMultiple"
                [checked]="row.get('isMultiple')"
              />
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="form-builder-row-buttons buttons">
      <button
        type="button"
        class="button is-small is-info"
        *ngIf="row.get('type') === 'select'"
        (click)="addOption()"
        translationEditableDirective="ADD_OPTION"
      >
        {{ 'ADD_OPTION' | translate }}
      </button>
      <button
        *ngIf="!row.get('isPropertyType')"
        type="button"
        class="button is-small is-danger"
        (click)="deleteRow()"
      >
        <i class="fas fa-trash-alt"></i>
      </button>
    </div>
  </div>

  <app-form-builder-option
    [isPropertyType]="isPropertyType"
    [option]="option"
    *ngFor="let option of row.get('options'); let index = index"
    [index]="index"
    [parent]="row.get('options')"
    (onAddOption)="addOption($event)"
    (onAddInput)="addInput($event)"
    (onAddSelect)="addSelect($event)"
    (onDeleteOption)="deleteOption($event)"
    (onDeleteRow)="deleteRow($event)"
    (onChangeField)="handleFieldChange($event)"
    (onChangeOptionsOrder)="handleOptionsOrderChange($event)"
  ></app-form-builder-option>
</div>
